import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import SphericProjector from 'materialisateur-js/src/SphericProjector';
import Loading from '../Loading';
import { VisiteOptions } from '../Visite/VisiteOptions';
import { MentionContractuel } from '../Mention/MentionContractuel';

const pieceSlugs = [
  'sejour',
  'entree',
  'cuisine',
  'ch1',
  'sdb',
  'sdb1',
  'ch2',
  'sdb2',
  'ch3',
  'ch4',
]; //Ordre des pièces dans le sélecteur
const sphericProjector = new SphericProjector();
export default function VisiteLot() {
  const { lot, settings } = useOutletContext();
  const [pieces, setPieces] = useState();
  const [currentScene, setCurrentScene] = useState();
  const params = useParams();
  const navigate = useNavigate();
  const nodeRef = useRef();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!nodeRef.current) return;
    nodeRef.current?.appendChild(sphericProjector.getDomElement());
    sphericProjector.resize(nodeRef.current.getBoundingClientRect(), true);
  }, [nodeRef.current]);

  const onresize = useCallback(() => {
    sphericProjector.resize(nodeRef.current.getBoundingClientRect());
  }, []);
  useEffect(() => {
    addEventListener('resize', onresize);
    return () => {
      removeEventListener('resize', onresize);
    };
  }, [onresize]);
  useEffect(() => {
    const visitePath = `${settings.mediaBaseUrl}/visites/${lot.key}`;
    fetch(visitePath + '/visite.json')
      .then((res) => res.json())
      .then((data) => {
        setPieces(
          data.scenes.sort(
            (a, b) =>
              pieceSlugs.indexOf(a.slug.toLowerCase()) -
              pieceSlugs.indexOf(b.slug.toLowerCase()),
          ),
        );
      });
  }, [lot, settings]);

  useEffect(() => {
    if (!(pieces && navigate && params)) return;
    const splat = params['*'];
    setLoading(true);
    if (splat) {
      const scene = pieces.find((p) => p.slug === splat);
      if (scene) {
        setCurrentScene(scene);
        sphericProjector.initTexture(
          `${settings.mediaBaseUrl}/visites/${lot.key}/${scene.filename}`,
          () => {
            sphericProjector.initPosition({
              long: -Math.PI / 2,
              lat: 0,
              fov: 90,
            });
            setLoading(false);
          },
        );
        return;
      }
    } else {
      navigate('./' + pieces[0].slug, { replace: true });
    }
  }, [pieces, navigate, params, settings, lot]);

  const handleChangePiece = (value) => {
    navigate('../' + value, { relative: 'path' });
  };

  const handlePevPiece = () => {
    const index = pieces.findIndex((p) => p.slug === currentScene.slug);
    if (index === 0) {
      return;
    }
    navigate('../' + pieces[index - 1].slug, { relative: 'path' });
  };

  const handleNextPiece = () => {
    const index = pieces.findIndex((p) => p.slug === currentScene.slug);
    if (index === pieces.length - 1) {
      return;
    }
    navigate('../' + pieces[index + 1].slug, { relative: 'path' });
  };

  return pieces ? (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative',
      }}
    >
      <MentionContractuel sx={{ zIndex: 1 }} />
      <Box
        ref={nodeRef}
        sx={{
          width: '100%',
          height: '100%',
          position: 'absolute',
        }}
      />
      {loading ? (
        <Box
          sx={{
            position: 'absolute',
            width: '100%',
            top: 0,
            bottom: 0,
          }}
        >
          <Loading />
        </Box>
      ) : null}

      {currentScene ? (
        <Box
          sx={{
            position: 'absolute',
            bottom: 30,
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        >
          <VisiteOptions
            pieces={pieces}
            currentScene={currentScene}
            handleChangePiece={handleChangePiece}
            handlePrevPiece={handlePevPiece}
            handleNextPiece={handleNextPiece}
          />
        </Box>
      ) : null}
    </Box>
  ) : null;
}
